
import { Button } from "@/components/ui/button";
import { Check } from "lucide-react";
import { ctaData } from "../data/landingPageData";
import EnhancedBetaSignupForm from "../EnhancedBetaSignupForm";

export const CTASection = () => {
  return (
    <div className="py-24 bg-gradient-to-br from-red-600 to-red-700">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-4xl text-center">
          <h2 className="text-3xl font-bold tracking-tight text-white sm:text-4xl">
            {ctaData.title}
          </h2>
          <p className="mt-6 text-lg leading-8 text-red-100">
            {ctaData.subtitle}
          </p>
          
          <div className="mt-10 flex items-center justify-center gap-6">
            <EnhancedBetaSignupForm 
              trigger={
                <Button size="lg" className="bg-white text-red-700 hover:bg-slate-50 px-8 py-4 text-lg font-semibold">
                  {ctaData.primaryCta}
                </Button>
              }
              source="cta_section"
            />
            <Button variant="outline" size="lg" className="border-white hover:bg-white/10 px-8 py-4 text-lg font-semibold text-red-950">
              {ctaData.secondaryCta}
            </Button>
          </div>
          
          <div className="mt-12 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
            {ctaData.features.map((feature, index) => (
              <div key={index} className="flex items-center justify-center text-red-100">
                <Check className="h-5 w-5 mr-2" />
                <span className="text-sm">{feature}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
